class HierarchyBridge {
    constructor(uri) {
        this._promiseReady = (async () => {
            const response = await fetch(uri);
            const script = await response.text();

            const worker = new Worker(`data:application/javascript;base64,${btoa(unescape(encodeURIComponent(script)))}`, { name: uri });
            const { port1, port2 } = new MessageChannel();

            port1.start();

            this._worker = worker;
            this._port = port1;

            await new Promise(resolve => {
                const onAttachedClient = ({ data: { type } }) => {
                    port1.removeEventListener("message", onAttachedClient);

                    if (type === "attach-reply") resolve();
                    else throw new Error(`Invalid response type '${type}'.`);
                }

                port1.addEventListener("message", onAttachedClient);
                worker.postMessage({ type: "attach" }, [port2]);
            });
        })();
    }

    async collectFastHierarchyMap(data, fastMap = {}) {
        return Object.assign(fastMap, await this._awaitAnswer("computeHierarchy", data));
    }

    async computeMinimizedHierarchy(data) {
        return await this._awaitAnswer("computeMinimizedHierarchy", data);
    }

    _awaitAnswer(type, ...payload) {
        console.log(`Bridge '${type}' -> ${payload}`);
        return new Promise(async (resolve, reject) => {
            await this._promiseReady;

            const port = this._port;
            const uuid = THREE.Math.generateUUID();

            function onMessage(result) {
                if (result.data.uuid !== uuid) return;
                if (result.data.type !== `${type}-reply`) throw new Error(`Message UUID contains incorrect message type, got '${result.data.type}' expected '${type}-reply'.`);

                if (result.data.error) reject(result.data.error);
                else resolve(result.data.payload);

                port.removeEventListener("message", onMessage);

                console.log(`(Done) Bridge '${type}' -> ${payload}`);
            }

            port.addEventListener("message", onMessage);
            port.postMessage({
                uuid,
                type,
                payload: [...payload]
            });
        });
    }
}

export default HierarchyBridge;
export { HierarchyBridge };